import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-card rounded-lg shadow p-6 min-h-[calc(100vh-120px)]" }
const _hoisted_2 = { class: "mb-6 flex justify-between items-center" }
const _hoisted_3 = { class: "flex items-center space-x-3" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  value: ""
}
const _hoisted_7 = {
  key: 1,
  value: ""
}
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_10 = { class: "flex space-x-3" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "flex gap-4 min-h-[calc(100vh-180px)]" }
const _hoisted_15 = { class: "w-1/5 bg-background rounded-md p-4 border border-border flex flex-col" }
const _hoisted_16 = { class: "space-y-2 mb-4" }
const _hoisted_17 = { class: "space-y-2" }
const _hoisted_18 = { class: "flex items-center space-x-2" }
const _hoisted_19 = ["value"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "flex-1 overflow-y-auto space-y-3 pr-2" }
const _hoisted_22 = { class: "flex justify-between items-start" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "flex space-x-1" }
const _hoisted_25 = ["onClick", "disabled"]
const _hoisted_26 = ["onClick", "disabled"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "w-4/5 bg-white rounded-md shadow p-6 flex flex-col" }
const _hoisted_30 = {
  key: 0,
  class: "flex-1 flex flex-col"
}
const _hoisted_31 = { class: "flex justify-between items-center mb-4" }
const _hoisted_32 = { class: "flex space-x-2" }
const _hoisted_33 = { class: "flex space-x-2" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_36 = { class: "space-y-4 flex-1 flex flex-col min-h-[500px]" }
const _hoisted_37 = { class: "flex items-center space-x-2 p-1 border border-gray-300 rounded-t-md bg-gray-50" }
const _hoisted_38 = { class: "relative inline-block mr-2" }
const _hoisted_39 = {
  key: 0,
  class: "absolute z-10 mt-1 bg-white border border-gray-300 rounded shadow-lg p-2",
  style: {"width":"200px"}
}
const _hoisted_40 = { class: "grid grid-cols-8 gap-1" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "relative inline-block" }
const _hoisted_43 = {
  key: 0,
  class: "absolute z-10 mt-1 bg-white border border-gray-300 rounded shadow-lg p-2",
  style: {"width":"200px"}
}
const _hoisted_44 = { class: "grid grid-cols-8 gap-1" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "w-full flex-1 min-h-[450px] border border-gray-300 border-t-0 rounded-b-md overflow-hidden" }
const _hoisted_47 = {
  ref: "editorFrame",
  class: "w-full h-full border-0",
  title: "Rich Text Editor",
  sandbox: "allow-same-origin"
}
const _hoisted_48 = {
  key: 0,
  class: "mt-4 p-4 border border-gray-300 rounded-md bg-gray-50"
}
const _hoisted_49 = { class: "grid grid-cols-1 md:grid-cols-2 gap-3" }
const _hoisted_50 = ["for"]
const _hoisted_51 = {
  key: 0,
  class: "ml-2 text-xs text-green-600 font-normal"
}
const _hoisted_52 = { class: "flex" }
const _hoisted_53 = ["id", "onUpdate:modelValue", "placeholder", "onChange", "readonly"]
const _hoisted_54 = {
  key: 1,
  class: "flex-1 flex items-center justify-center"
}
const _hoisted_55 = { class: "text-center" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = {
  key: 1,
  class: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
}
const _hoisted_58 = { class: "bg-white rounded-lg shadow-xl w-11/12 max-w-6xl max-h-[90vh] flex flex-col" }
const _hoisted_59 = { class: "p-4 border-b border-gray-200 flex justify-between items-center" }
const _hoisted_60 = { class: "p-4 flex-1 overflow-y-auto flex flex-row gap-6" }
const _hoisted_61 = { class: "w-1/2" }
const _hoisted_62 = { class: "p-4 border-t border-gray-200 flex justify-end space-x-2" }
const _hoisted_63 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmailReviewModal = _resolveComponent("EmailReviewModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[34] || (_cache[34] = _createElementVNode("h2", { class: "text-xl font-semibold" }, "Presentation Management", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[28] || (_cache[28] = _createElementVNode("label", {
              for: "process-selector",
              class: "mr-2 text-sm font-medium text-gray-700"
            }, "Forecasting Process:", -1)),
            _withDirectives(_createElementVNode("select", {
              id: "process-selector",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProcessId) = $event)),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleProcessChange && _ctx.handleProcessChange(...args))),
              class: "bg-white border border-gray-300 text-gray-700 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-64 p-2.5",
              disabled: _ctx.loading
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("option", _hoisted_6, "Loading processes..."))
                : (_ctx.processes.length === 0)
                  ? (_openBlock(), _createElementBlock("option", _hoisted_7, "No processes available"))
                  : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processes, (process) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: process.id,
                  value: process.id
                }, _toDisplayString(process.name) + " (" + _toDisplayString(_ctx.formatProcessDate(process.start_date)) + ") ", 9, _hoisted_8))
              }), 128))
            ], 40, _hoisted_5), [
              [_vModelSelect, _ctx.selectedProcessId]
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[27] || (_cache[27] = [
                  _createElementVNode("svg", {
                    class: "animate-spin h-5 w-5 text-blue-500",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("circle", {
                      class: "opacity-25",
                      cx: "12",
                      cy: "12",
                      r: "10",
                      stroke: "currentColor",
                      "stroke-width": "4"
                    }),
                    _createElementVNode("path", {
                      class: "opacity-75",
                      fill: "currentColor",
                      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.savePresentation && _ctx.savePresentation(...args))),
              class: "px-4 py-2 border border-primary text-primary bg-white rounded-md hover:bg-primary/10 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 flex items-center",
              disabled: _ctx.isSavingPresentation
            }, [
              (_ctx.isSavingPresentation)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _cache[29] || (_cache[29] = [
                    _createElementVNode("svg", {
                      class: "animate-spin h-5 w-5 text-white",
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("circle", {
                        class: "opacity-25",
                        cx: "12",
                        cy: "12",
                        r: "10",
                        stroke: "currentColor",
                        "stroke-width": "4"
                      }),
                      _createElementVNode("path", {
                        class: "opacity-75",
                        fill: "currentColor",
                        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      })
                    ], -1)
                  ])))
                : _createCommentVNode("", true),
              _cache[30] || (_cache[30] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-5 w-5 mr-2",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
                })
              ], -1)),
              _cache[31] || (_cache[31] = _createTextVNode(" Save Presentation "))
            ], 8, _hoisted_11),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.exportAllSlides && _ctx.exportAllSlides(...args))),
              class: "px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 flex items-center",
              disabled: _ctx.slides.length === 0 || _ctx.isExporting
            }, [
              _cache[32] || (_cache[32] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-5 w-5 mr-2",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.isExporting ? 'Exporting...' : 'Export to PDF'), 1)
            ], 8, _hoisted_13),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openEmailModal && _ctx.openEmailModal(...args))),
              class: "px-4 py-2 border border-primary text-primary bg-white rounded-md hover:bg-primary/10 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 flex items-center"
            }, _cache[33] || (_cache[33] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-5 w-5 mr-2",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                })
              ], -1),
              _createTextVNode(" Email ")
            ]))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[38] || (_cache[38] = _createElementVNode("h3", { class: "text-lg font-semibold mb-2" }, "Presentation Slides", -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _withDirectives(_createElementVNode("select", {
                  id: "template-select",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedTemplateId) = $event)),
                  class: "flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.htmlTemplates, (template) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: template.id,
                      value: template.id
                    }, _toDisplayString(template.name), 9, _hoisted_19))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedTemplateId]
                ])
              ])
            ]),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addNewSlide && _ctx.addNewSlide(...args))),
              class: "w-full px-4 py-2 bg-white text-primary border border-primary rounded-md hover:bg-primary/10 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
              disabled: _ctx.isLoading
            }, _toDisplayString(_ctx.isLoading ? 'Loading...' : '+ Add Slide Template'), 9, _hoisted_20)
          ]),
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'slide-' + index,
                class: "bg-white p-3 rounded shadow-sm border border-gray-200 hover:shadow-md transition-shadow"
              }, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", {
                    class: "font-medium text-sm flex-1 cursor-pointer",
                    onClick: ($event: any) => (_ctx.selectSlide(index))
                  }, " Slide " + _toDisplayString(index + 1), 9, _hoisted_23),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.moveSlide(index, 'up')),
                      class: _normalizeClass(["text-gray-500 hover:text-primary p-1 focus:outline-none", { 'opacity-30 cursor-not-allowed': index === 0 }]),
                      disabled: index === 0,
                      title: "Move Up"
                    }, _cache[35] || (_cache[35] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-4 w-4",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M5 15l7-7 7 7"
                        })
                      ], -1)
                    ]), 10, _hoisted_25),
                    _createElementVNode("button", {
                      onClick: ($event: any) => (_ctx.moveSlide(index, 'down')),
                      class: _normalizeClass(["text-gray-500 hover:text-primary p-1 focus:outline-none", { 'opacity-30 cursor-not-allowed': index === _ctx.slides.length - 1 }]),
                      disabled: index === _ctx.slides.length - 1,
                      title: "Move Down"
                    }, _cache[36] || (_cache[36] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-4 w-4",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M19 9l-7 7-7-7"
                        })
                      ], -1)
                    ]), 10, _hoisted_26),
                    _createElementVNode("button", {
                      onClick: _withModifiers(($event: any) => (_ctx.deleteSlide(index)), ["stop"]),
                      class: "text-gray-500 hover:text-red-500 p-1 focus:outline-none",
                      title: "Delete Slide"
                    }, _cache[37] || (_cache[37] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-4 w-4",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        })
                      ], -1)
                    ]), 8, _hoisted_27)
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["text-xs text-gray-500 mt-1 cursor-pointer", { 'font-bold text-primary': _ctx.selectedSlideIndex === index }]),
                  onClick: ($event: any) => (_ctx.selectSlide(index))
                }, _toDisplayString(slide.title || 'Untitled Slide'), 11, _hoisted_28)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          (_ctx.selectedSlide)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      id: "preview-title",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedSlide.title) = $event)),
                      type: "text",
                      class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-xl font-bold",
                      placeholder: "Enter slide title",
                      onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveSlide && _ctx.saveSlide(...args)))
                    }, null, 544), [
                      [_vModelText, _ctx.selectedSlide.title]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("button", {
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.fillContentWithAI && _ctx.fillContentWithAI(...args))),
                      class: "px-3 py-1 bg-secondary text-white rounded-md hover:bg-secondary/90 focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2 text-sm flex items-center",
                      disabled: _ctx.isGeneratingContent
                    }, [
                      (_ctx.isGeneratingContent)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, _cache[39] || (_cache[39] = [
                            _createElementVNode("svg", {
                              class: "animate-spin h-4 w-4 text-white",
                              xmlns: "http://www.w3.org/2000/svg",
                              fill: "none",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                              }),
                              _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              })
                            ], -1)
                          ])))
                        : _createCommentVNode("", true),
                      _cache[40] || (_cache[40] = _createTextVNode(" Fill Content with AI "))
                    ], 8, _hoisted_34),
                    _createElementVNode("button", {
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openPromptEditor && _ctx.openPromptEditor(...args))),
                      class: "px-3 py-1 border border-secondary text-secondary rounded-md hover:bg-secondary/10 focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2 text-sm flex items-center",
                      title: "Edit AI Prompt for this template"
                    }, _cache[41] || (_cache[41] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "h-4 w-4 mr-1",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        })
                      ], -1),
                      _createTextVNode(" Edit Prompt ")
                    ]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("button", {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.formatText('bold'))),
                      class: "p-1 hover:bg-gray-200 rounded",
                      title: "Bold"
                    }, _cache[42] || (_cache[42] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        viewBox: "0 0 16 16"
                      }, [
                        _createElementVNode("path", { d: "M8.21 13c2.106 0 3.412-1.087 3.412-2.823 0-1.306-.984-2.283-2.324-2.386v-.055a2.176 2.176 0 0 0 1.852-2.14c0-1.51-1.162-2.46-3.014-2.46H3.843V13H8.21zM5.908 4.674h1.696c.963 0 1.517.451 1.517 1.244 0 .834-.629 1.32-1.73 1.32H5.908V4.673zm0 6.788V8.598h1.73c1.217 0 1.88.492 1.88 1.415 0 .943-.643 1.449-1.832 1.449H5.907z" })
                      ], -1)
                    ])),
                    _createElementVNode("button", {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.formatText('italic'))),
                      class: "p-1 hover:bg-gray-200 rounded",
                      title: "Italic"
                    }, _cache[43] || (_cache[43] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        viewBox: "0 0 16 16"
                      }, [
                        _createElementVNode("path", { d: "M7.991 11.674 9.53 4.455c.123-.595.246-.71 1.347-.807l.11-.52H7.211l-.11.52c1.06.096 1.128.212 1.005.807L6.57 11.674c-.123.595-.246.71-1.346.806l-.11.52h3.774l.11-.52c-1.06-.095-1.129-.211-1.006-.806z" })
                      ], -1)
                    ])),
                    _createElementVNode("button", {
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.formatText('underline'))),
                      class: "p-1 hover:bg-gray-200 rounded",
                      title: "Underline"
                    }, _cache[44] || (_cache[44] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        viewBox: "0 0 16 16"
                      }, [
                        _createElementVNode("path", { d: "M5.313 3.136h-1.23V9.54c0 2.105 1.47 3.623 3.917 3.623s3.917-1.518 3.917-3.623V3.136h-1.23v6.323c0 1.49-.978 2.57-2.687 2.57-1.709 0-2.687-1.08-2.687-2.57V3.136zM12.5 15h-9v-1h9v1z" })
                      ], -1)
                    ])),
                    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "h-4 border-l border-gray-300 mx-1" }, null, -1)),
                    _createElementVNode("button", {
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.formatText('insertUnorderedList'))),
                      class: "p-1 hover:bg-gray-200 rounded",
                      title: "Bullet List"
                    }, _cache[45] || (_cache[45] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        viewBox: "0 0 16 16"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                        })
                      ], -1)
                    ])),
                    _createElementVNode("button", {
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.formatText('insertOrderedList'))),
                      class: "p-1 hover:bg-gray-200 rounded",
                      title: "Numbered List"
                    }, _cache[46] || (_cache[46] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        viewBox: "0 0 16 16"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM1.713 11.865v-.474H2c.217 0 .363-.137.363-.317 0-.185-.158-.31-.361-.31-.223 0-.367.152-.373.31h-.59c.016-.467.373-.787.986-.787.588-.002.954.291.957.703a.595.595 0 0 1-.492.594v.033a.615.615 0 0 1 .569.631c.003.533-.502.8-1.051.8-.656 0-1-.37-1.008-.794h.582c.008.178.186.306.422.309.254 0 .424-.145.422-.35-.002-.195-.155-.348-.414-.348h-.3zm-.004-4.699h-.604v-.035c0-.408.295-.844.958-.844.583 0 .96.326.96.756 0 .389-.257.617-.476.848l-.537.572v.03h1.054V9H1.143v-.395l.957-.99c.138-.142.293-.304.293-.508 0-.18-.147-.32-.342-.32a.33.33 0 0 0-.342.338v.041zM2.564 5h-.635V2.924h-.031l-.598.42v-.567l.629-.443h.635V5z"
                        })
                      ], -1)
                    ])),
                    _cache[54] || (_cache[54] = _createElementVNode("div", { class: "h-4 border-l border-gray-300 mx-1" }, null, -1)),
                    _createElementVNode("button", {
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.formatText('justifyLeft'))),
                      class: "p-1 hover:bg-gray-200 rounded",
                      title: "Align Left"
                    }, _cache[47] || (_cache[47] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        viewBox: "0 0 16 16"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M2 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                        })
                      ], -1)
                    ])),
                    _createElementVNode("button", {
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.formatText('justifyCenter'))),
                      class: "p-1 hover:bg-gray-200 rounded",
                      title: "Align Center"
                    }, _cache[48] || (_cache[48] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        viewBox: "0 0 16 16"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M4 12.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5zm2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                        })
                      ], -1)
                    ])),
                    _cache[55] || (_cache[55] = _createElementVNode("div", { class: "h-4 border-l border-gray-300 mx-1" }, null, -1)),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("button", {
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.toggleColorPicker('text'))),
                        class: "p-1 hover:bg-gray-200 rounded flex items-center",
                        title: "Text Color"
                      }, [
                        _cache[49] || (_cache[49] = _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "16",
                          height: "16",
                          fill: "currentColor",
                          viewBox: "0 0 16 16"
                        }, [
                          _createElementVNode("path", { d: "M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708l.647.646L4.146 8l-1.5 1.5-.354-.354a.5.5 0 0 0-.708.708l.354.354-.5.5a.5.5 0 0 0 .708.708l.5-.5.354.354a.5.5 0 0 0 .708-.708L3.354 9.5l1.5-1.5L8.5 4.354l.646.646a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708l-.708.708z" })
                        ], -1)),
                        _createElementVNode("div", {
                          class: "w-4 h-4 ml-1 border border-gray-300",
                          style: _normalizeStyle({ backgroundColor: _ctx.currentTextColor })
                        }, null, 4)
                      ]),
                      (_ctx.showColorPicker === 'text')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _cache[50] || (_cache[50] = _createElementVNode("div", { class: "text-xs font-medium mb-1 text-gray-700" }, "Text Color", -1)),
                            _createElementVNode("div", _hoisted_40, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorOptions, (color) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: color,
                                  class: "w-5 h-5 cursor-pointer border border-gray-300 hover:border-gray-600",
                                  style: _normalizeStyle({ backgroundColor: color }),
                                  onClick: ($event: any) => (_ctx.applyTextColor(color))
                                }, null, 12, _hoisted_41))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("button", {
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.toggleColorPicker('background'))),
                        class: "p-1 hover:bg-gray-200 rounded flex items-center",
                        title: "Background Color"
                      }, [
                        _cache[51] || (_cache[51] = _createElementVNode("svg", {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "16",
                          height: "16",
                          fill: "currentColor",
                          viewBox: "0 0 16 16"
                        }, [
                          _createElementVNode("path", { d: "M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z" })
                        ], -1)),
                        _createElementVNode("div", {
                          class: "w-4 h-4 ml-1 border border-gray-300",
                          style: _normalizeStyle({ backgroundColor: _ctx.currentBgColor })
                        }, null, 4)
                      ]),
                      (_ctx.showColorPicker === 'background')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _cache[52] || (_cache[52] = _createElementVNode("div", { class: "text-xs font-medium mb-1 text-gray-700" }, "Background Color", -1)),
                            _createElementVNode("div", _hoisted_44, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colorOptions, (color) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: color,
                                  class: "w-5 h-5 cursor-pointer border border-gray-300 hover:border-gray-600",
                                  style: _normalizeStyle({ backgroundColor: color }),
                                  onClick: ($event: any) => (_ctx.applyBackgroundColor(color))
                                }, null, 12, _hoisted_45))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("iframe", _hoisted_47, null, 512)
                  ]),
                  (_ctx.extractedPlaceholders.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                        _cache[56] || (_cache[56] = _createElementVNode("h3", { class: "text-md font-semibold mb-2 flex items-center" }, [
                          _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-5 w-5 mr-2 text-primary",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                            })
                          ]),
                          _createTextVNode(" Template Placeholders ")
                        ], -1)),
                        _cache[57] || (_cache[57] = _createElementVNode("p", { class: "text-sm text-gray-600 mb-3" }, "Edit the values for placeholders in this slide template:", -1)),
                        _createElementVNode("div", _hoisted_49, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extractedPlaceholders, (placeholder, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "flex flex-col"
                            }, [
                              _createElementVNode("label", {
                                for: `placeholder-${index}`,
                                class: "text-xs font-medium text-gray-700 mb-1 flex items-center"
                              }, [
                                _createTextVNode(_toDisplayString(placeholder.name) + " ", 1),
                                (placeholder.applied)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, "(Applied)"))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_50),
                              _createElementVNode("div", _hoisted_52, [
                                _withDirectives(_createElementVNode("input", {
                                  id: `placeholder-${index}`,
                                  "onUpdate:modelValue": ($event: any) => ((placeholder.value) = $event),
                                  type: "text",
                                  class: _normalizeClass([
                        'flex-1 px-3 py-2 border rounded-md text-sm',
                        placeholder.applied
                          ? 'bg-gray-100 border-gray-300 text-gray-700 cursor-not-allowed'
                          : 'border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent'
                      ]),
                                  placeholder: placeholder.applied ? 'Value applied' : `Enter value for ${placeholder.name}`,
                                  onChange: ($event: any) => (_ctx.updatePlaceholderInTemplate(placeholder)),
                                  readonly: placeholder.applied
                                }, null, 42, _hoisted_53), [
                                  [_vModelText, placeholder.value]
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.selectedSlide)
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _cache[58] || (_cache[58] = _createElementVNode("p", { class: "text-gray-500 mb-4" }, "Select a slide from the left panel or create a new one", -1)),
                  _createElementVNode("button", {
                    onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.addNewSlide && _ctx.addNewSlide(...args))),
                    class: "px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
                    disabled: _ctx.isLoading
                  }, _toDisplayString(_ctx.isLoading ? 'Loading...' : 'Add New Slide Template'), 9, _hoisted_56)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.showEmailModal)
      ? (_openBlock(), _createBlock(_component_EmailReviewModal, {
          key: 0,
          isOpen: _ctx.showEmailModal,
          recipientEmail: _ctx.emailRecipient,
          "process-step-type": _ctx.currentProcessStepType,
          templateVariables: _ctx.templateVariables,
          onClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showEmailModal = false)),
          onSendSuccess: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showEmailModal = false))
        }, null, 8, ["isOpen", "recipientEmail", "process-step-type", "templateVariables"]))
      : _createCommentVNode("", true),
    (_ctx.showPromptEditor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _cache[60] || (_cache[60] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Edit AI Prompt", -1)),
              _createElementVNode("button", {
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showPromptEditor = false)),
                class: "text-gray-500 hover:text-gray-700"
              }, _cache[59] || (_cache[59] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-6 w-6",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ]))
            ]),
            _createElementVNode("div", _hoisted_60, [
              _cache[61] || (_cache[61] = _createStaticVNode("<div class=\"w-1/2\"><div><p class=\"text-sm text-gray-600 mb-2\"> Create a custom AI prompt for this template. You can use the following placeholders: </p><ul class=\"text-xs text-gray-500 list-disc pl-5 mb-4\"><li><code>{SLIDE_TITLE}</code> - Will be replaced with the slide title</li><li><code>{SLIDE_CONTENT}</code> - Will be replaced with the current slide HTML content</li><li><code>{SLIDE_PLACEHOLDERS}</code> - Will be replaced with a structured list of all placeholders in the template, separated into &quot;already applied&quot; and &quot;not yet applied&quot; sections, with clear instructions for the AI on how to handle them</li><li><code>{CURRENT_FORECASTING_PERIOD}</code> - Will be replaced with the current forecasting period name and date</li></ul><div class=\"text-xs text-gray-600 bg-gray-100 p-2 rounded-md mb-4\"><p class=\"font-medium mb-1\">Example of {SLIDE_PLACEHOLDERS} format:</p><pre class=\"text-xs overflow-x-auto\">TEMPLATE PLACEHOLDERS:\n\nALREADY APPLIED (DO NOT CHANGE THESE):\n- {YEAR} = &quot;2025&quot;\n- {QUARTER} = &quot;Q2&quot;\n\nNOT YET APPLIED (PLEASE FILL THESE):\n- {REVENUE}\n- {GROWTH_PERCENT}\n\nINSTRUCTIONS FOR PLACEHOLDERS:\n1. DO NOT modify already applied placeholders - keep them exactly as they are\n2. Replace unapplied placeholders with appropriate values\n3. Use consistent formatting for similar types of data\n4. Format financial numbers with commas for thousands (e.g., 1,234)\n5. Include % sign for percentages (e.g., 12.5%)\n              </pre></div></div></div>", 1)),
              _createElementVNode("div", _hoisted_61, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.editingPrompt) = $event)),
                  class: "w-full h-full min-h-[400px] px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent",
                  placeholder: "Enter a custom prompt for this template..."
                }, null, 512), [
                  [_vModelText, _ctx.editingPrompt]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("button", {
                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showPromptEditor = false)),
                class: "px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
              }, " Cancel "),
              _createElementVNode("button", {
                onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.saveCustomPrompt && _ctx.saveCustomPrompt(...args))),
                class: "px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
                disabled: _ctx.isSavingPrompt
              }, _toDisplayString(_ctx.isSavingPrompt ? 'Saving...' : 'Save Prompt'), 9, _hoisted_63)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}